import { Link } from 'react-router-dom'
import { useLanguage } from '@/i18n/LanguageContext'
import { SectionHeading } from '@/components/ui/SectionHeading'
import { FAQ_ITEMS } from '@/lib/faq'
import { FaqAccordion } from './FaqAccordion'

/**
 * #faq — Phase 4. Real Q&A (master prompt §2.9), single responsive data
 * source (no mobile-overlay duplicate). This session added a closing
 * pointer to the blog (real routed page since Phase 5) for people who want
 * more detail than an FAQ answer gives.
 */
export function FaqSection() {
  const { t, lang } = useLanguage()

  return (
    <section id="faq" className="px-6 py-section-gap md:px-margin-desktop">
      <div className="mx-auto flex max-w-container flex-col gap-10">
        <SectionHeading title={t('faq-title')} subtitle={t('faq-sub')} />
        <div className="mx-auto w-full max-w-3xl">
          <FaqAccordion items={FAQ_ITEMS} />
        </div>
        <p className="mx-auto max-w-3xl text-center text-sm text-foreground-muted">
          {t('faq-blog-cta-pre')}{' '}
          <Link to={`/${lang}/blog`} className="font-semibold text-accent-fire underline-offset-4 hover:underline">
            {t('faq-blog-cta-link')}
          </Link>{' '}
          {t('faq-blog-cta-post')}
        </p>
      </div>
    </section>
  )
}
